import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'defaultTitle'
	| 'stopTaskLabel'
	| 'doneButtonLabel'
	| 'progressBarLabel'
	| 'awaitingUserResponseTitle'
	| 'skipAllButton'
	| 'awaitingPlanAcceptanceTitle'
	| 'cancelPlanButton'
	| 'sendButtonSpinnerLabel'
	| 'modifyPlanPlaceholder'
	| 'todoStepInProgressLabel'
	| 'todoListLabel'
	| 'taskElapsedTimeLabel';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		defaultTitle: {
			id: 'conversation-assistant.task-progress-view.default-title',
			defaultMessage: 'Task in progress',
			description:
				'Default title shown in the task progress view when no specific title is provided',
		},
		stopTaskLabel: {
			id: 'conversation-assistant.task-progress-view.stop-task-label',
			defaultMessage: 'Stop task',
			description: 'Accessible label for the stop button that cancels the current task',
		},
		doneButtonLabel: {
			id: 'conversation-assistant.task-progress-view.done-button-label',
			defaultMessage: 'Done',
			description: 'Label for the button shown when a task has completed',
		},
		progressBarLabel: {
			id: 'conversation-assistant.task-progress-view.progress-bar-label',
			defaultMessage: 'Task progress',
			description: 'Accessible label for the task progress bar',
		},
		awaitingUserResponseTitle: {
			id: 'conversation-assistant.task-progress-view.awaiting-user-response.title',
			defaultMessage: 'Awaiting your response',
			description: 'Shimmer text shown when the task is awaiting user response to questions',
		},
		skipAllButton: {
			id: 'conversation-assistant.task-progress-view.awaiting-user-response.skip-all',
			defaultMessage: 'Skip all',
			description: 'Button label to skip all pending questions',
		},
		awaitingPlanAcceptanceTitle: {
			id: 'conversation-assistant.task-progress-view.awaiting-plan-acceptance.title',
			defaultMessage: 'Awaiting your response',
			description: 'Shimmer text shown when the task is awaiting plan acceptance',
		},
		cancelPlanButton: {
			id: 'conversation-assistant.task-progress-view.awaiting-plan-acceptance.cancel-plan',
			defaultMessage: 'Cancel plan',
			description:
				'Text shown on a button in the task progress view when the user is awaiting plan acceptance. Clicking this button cancels the current plan.',
		},
		sendButtonSpinnerLabel: {
			id: 'conversation-assistant.task-progress-view.send-button-spinner-label',
			defaultMessage: 'Waiting',
			description: 'Accessible label for the spinner shown in the disabled send button area',
		},
		modifyPlanPlaceholder: {
			id: 'conversation-assistant.task-progress-view.modify-plan.placeholder',
			defaultMessage: 'Describe how to modify the plan...',
			description:
				'Placeholder text shown in the chat input when the user is modifying a task plan',
		},
		todoStepInProgressLabel: {
			id: 'conversation-assistant.task-progress-view.todo-step-in-progress-label',
			defaultMessage: 'Step in progress',
			description:
				'Accessible label for the spinner shown next to a todo step that is currently running',
		},
		todoListLabel: {
			id: 'conversation-assistant.task-progress-view.todo-list-label',
			defaultMessage: 'Task steps',
			description: 'Accessible label for the list of todo steps shown during task execution',
		},
		taskElapsedTimeLabel: {
			id: 'conversation-assistant.task-progress-view.elapsed-time-label',
			defaultMessage: 'Elapsed time: {time}',
			description:
				'Accessible label for the elapsed time counter in the task progress view, announced to screen readers',
		},
	});

export default message;
